import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkActionToolbar = ({ selectedCount, onClearSelection, onBulkAction }) => {
  const statusOptions = [
    { value: '', label: 'Update Status...' },
    { value: 'contract-signed', label: 'Contract Signed' },
    { value: 'lc-received', label: 'LC Received' },
    { value: 'loading', label: 'Loading' },
    { value: 'in-transit', label: 'In Transit' },
    { value: 'discharged', label: 'Discharged' },
    { value: 'completed', label: 'Completed' }
  ];

  const handleStatusUpdate = (status) => {
    if (status) {
      onBulkAction('updateStatus', status);
    }
  };

  if (selectedCount === 0) return null;

  return (
    <div className="bg-primary/10 border border-primary/20 rounded-lg p-4 mb-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <Icon name="CheckSquare" size={20} color="var(--color-primary)" />
            <span className="text-sm font-medium text-foreground">
              {selectedCount} {selectedCount === 1 ? 'shipment' : 'shipments'} selected
            </span>
          </div>
          <button
            onClick={onClearSelection}
            className="text-sm text-primary hover:underline"
          >
            Clear selection
          </button>
        </div>

        <div className="flex items-center gap-2">
          <Select
            options={statusOptions}
            value=""
            onChange={handleStatusUpdate}
            placeholder="Update Status..."
            className="w-48"
          />
          
          <Button
            variant="outline"
            size="sm"
            iconName="Upload"
            iconPosition="left"
            onClick={() => onBulkAction('uploadDocuments')}
          >
            Upload Documents
          </Button>

          <Button
            variant="outline"
            size="sm"
            iconName="Mail"
            iconPosition="left"
            onClick={() => onBulkAction('sendNotification')}
          >
            Send Notification
          </Button>

          <Button
            variant="outline"
            size="sm"
            iconName="Download"
            iconPosition="left"
            onClick={() => onBulkAction('export')}
          >
            Export Selected
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActionToolbar;